__turbopack_context__.v({
  "map": "ArticleFooter-module-scss-module__rpHnHa__map",
  "section": "ArticleFooter-module-scss-module__rpHnHa__section",
  "tagsSection": "ArticleFooter-module-scss-module__rpHnHa__tagsSection",
  "tagsTitle": "ArticleFooter-module-scss-module__rpHnHa__tagsTitle",
});
